import { cloneElement, isValidElement, type ReactElement } from "react"
import { cn } from "@local/utils/src/cn"

interface PillProps {
  children: ReactElement<{ className?: string }>
  className?: string
}

export const Pill = ({ children, className }: PillProps) => {
  if (!isValidElement(children)) return null

  return cloneElement(children, {
    className: cn("rounded-full", children.props.className, className),
  })
}
